export type LanguageCode = 'kk' | 'ru';

export const landingContent = {
  kk: {
    nav: {
      links: [
        { label: 'Жабдық', href: '#equipment' },
        { label: 'Шешімдер', href: '#solutions' },
        { label: 'Салалар', href: '#industries' },
        { label: 'Артықшылықтар', href: '#why-us' },
        { label: 'Байланыс', href: '#contact' },
      ],
      consultation: 'Кеңес алу',
      menuLabel: 'Мәзірді ашу',
      closeLabel: 'Мәзірді жабу',
    },
    hero: {
      eyebrow: 'Mesutronic жабдығын Қазақстанға жеткізу',
      title: 'Mesutronic металл детекторлары',
      titleAccent: 'өндірісті қорғауға арналған',
      subtitle:
        'Қазақстандағы азық-түлік және фармацевтика кәсіпорындары үшін өнеркәсіптік металл детекторлар мен инспекциялық жүйелерді жеткізу және таңдау',
      ctaPrimary: 'Жабдықты таңдау',
      ctaSecondary: 'Кеңес алу',
      imageAlt: 'Конвейерлік желідегі өнеркәсіптік металл детектор',
      heroImage: '/images/landing/hero.jpg',
      advantages: [
        'Fe, Non-Fe және тот баспайтын болатты анықтау',
        'Конвейерлерге, құбырларға және сусымалы ағындарға арналған шешімдер',
        'Өнімге, қаптамаға және желі жылдамдығына қарай таңдау',
      ],
    },
    trust: {
      eyebrow: 'Mesutronic жабдығын Қазақстанға жеткізу',
      title: 'Mesutronic жабдығы Германияда өндіріледі. Қазақстанға жеткізу',
      subtitle:
        'Өнім сапасын бақылауға және жабдықты қорғауға арналған өнеркәсіптік металл детекторлар мен инспекциялық жүйелер',
      imageAlt: 'Kirchberg im Wald, Германия қаласындағы Mesutronic GmbH ғимараты',
      heading: 'Қазақстанның өнеркәсіптік желілері үшін Mesutronic неміс өндірісі',
      paragraphs: [
        'Mesutronic GmbH 30 жылдан астам уақыт бойы металл және бөгде қоспаларды анықтайтын өнеркәсіптік жүйелерді әзірлеп, өндіріп келеді. Компанияның бас кеңсесі мен өндірісі Kirchberg im Wald, Германия қаласында орналасқан, ал жабдық ондаған елдегі кәсіпорындарда қолданылады.',
        'Mesutronic желісінде азық-түлік өнеркәсібі, фармацевтика, гигиеналық өнімдер, пластик, тоқыма, ағаш өңдеу және тау-кен секторы үшін металл детекторлар, металл сепараторлар және X-ray инспекциялық жүйелер бар. Шешімдер өнімге, қаптамаға, желі жылдамдығына және сұрыптап шығару талаптарына қарай таңдалады.',
        'Қазақстан кәсіпорындарына біз нақты өндірістік міндетке сай Mesutronic жабдығын таңдауға, техникалық спецификация дайындауға және Германиядан жеткізуді логистика, құжаттама және нысанда енгізу шарттарын ескере отырып ұйымдастыруға көмектесеміз.',
      ],
      stats: ['30+ жыл тәжірибе', '230 қызметкер', '50 ел', '70% экспорт'],
    },
    tasks: {
      eyebrow: 'Шешілетін міндеттер',
      title: 'Металл қоспаларын анықтауға арналған жабдық',
      subtitle:
        'Mesutronic өнеркәсіптік металл детекторлары мен металл сепараторлары Қазақстандағы өндірістік желілердің негізгі міндеттерін шешеді',
      items: [
        {
          id: 1,
          title: 'Өнім мен шикізаттағы металды анықтау',
          description:
            'Өнеркәсіптік металл детектор өндірістің барлық кезеңінде темірді, түсті металдарды, алюминийді, мысты және тот баспайтын болатты анықтайды.',
          icon: 'ri-radar-line',
        },
        {
          id: 2,
          title: 'Технологиялық жабдықты қорғау',
          description:
            'Металл қоспалары ұсатқыштарды, диірмендерді, экструдерлерді және сорғыларды зақымдайды. Өндіріске арналған металл сепаратор металды жабдыққа жетпей тұрып алып тастайды.',
          icon: 'ri-shield-check-line',
        },
        {
          id: 3,
          title: 'Шағымдар мен қайтарымдарды азайту',
          description:
            'Дайын өнімдегі металл жеткізуге қатысты шағымдар мен айыппұлдарға себеп болады. Желідегі инспекция ақаудың партияға шығуын болдырмайды.',
          icon: 'ri-arrow-down-circle-line',
        },
        {
          id: 4,
          title: 'Қаптау және жөнелту алдындағы тексеру',
          description:
            'Өнімді қаптау немесе тапсырыс берушіге жөнелту алдында финалдық инспекция. Ақаулы өнімнің партияға түсуін болдырмайды.',
          icon: 'ri-line-chart-line',
        },
        {
          id: 5,
          title: 'Қауіпсіздік талаптарына сәйкестік',
          description:
            'HACCP, BRC және өндірушілердің ішкі стандарттары физикалық қоспаларды бақылауды талап етеді. Жабдық әрбір іске қосылуды тіркеп, құжаттайды.',
          icon: 'ri-file-shield-line',
        },
      ],
    },
    equipment: {
      eyebrow: 'Mesutronic жабдығы',
      title: 'Mesutronic өндірісінің металл детекторлары',
      subtitle:
        'Конвейерлік, құбырлық, гравитациялық, қаптау және фармацевтикалық желілерге арналған Mesutronic шешімдерін таңдау және жеткізу',
      items: [
        {
          id: 1,
          title: 'Metron 07 CI конвейерлік металл детекторы',
          description:
            'Конвейерлік желілерде дана және қапталған өнімді бақылауға арналған инспекциялық жүйе.',
          image: '/images/landing/mesutronic-metron-07-ci.jpg',
          features: ['Конвейерлік желі', 'Қапталған өнім', 'Fe, Non-Fe, SS бақылауы'],
        },
        {
          id: 2,
          title: 'MEATLINE 07 құбырлық металл детекторы',
          description:
            'Ет фаршын, паста тәрізді және тұтқыр өнімдерді құбыр ішінде бақылауға арналған шешім.',
          image: '/images/landing/mesutronic-meatline-07.jpg',
          features: ['Ет өндірісі', 'Паста тәрізді өнімдер', 'Құбырда жұмыс істеу'],
        },
        {
          id: 3,
          title: 'Pipeline 07 құбырлық металл детекторы',
          description:
            'Жабық желілердегі сұйық, паста тәрізді және айдалатын өнімдерге арналған металл детектор.',
          image: '/images/landing/mesutronic-pipeline-07.jpg',
          features: ['Сұйық өнімдер', 'Жабық желі', 'Санитарлық орындалым'],
        },
        {
          id: 4,
          title: 'Quicktron 07 RH гравитациялық металл детекторы',
          description:
            'Еркін құлау режиміндегі сусымалы өнімдерді ластанған ағынды автоматты бұру арқылы бақылау жүйесі.',
          image: '/images/landing/mesutronic-quicktron-07-rh.jpg',
          features: ['Сусымалы өнімдер', 'Еркін құлау', 'Автоматты бұру'],
        },
        {
          id: 5,
          title: 'METRON 07 FlatLine мойындық металл детекторы',
          description:
            'Тік қаптау машиналары мен фасовка желілеріне орнатуға арналған ықшам мойындық металл детектор.',
          image: '/images/landing/mesutronic-metron-07-flatline.jpg',
          features: ['Тік қаптау', 'Ықшам орнату', 'Фасовка алдындағы бақылау'],
        },
        {
          id: 6,
          title: 'PHARMATRON 07 таблеткаларға арналған металл детектор',
          description:
            'Фармацевтикалық өндірісте таблеткалар мен капсулаларды бақылауға арналған мамандандырылған металл детектор.',
          image: '/images/landing/mesutronic-pharmatron-07.jpg',
          features: ['Фармацевтика', 'Таблеткалар мен капсулалар', 'Жоғары сезімталдық'],
        },
      ],
    },
    solutions: {
      eyebrow: 'Өндіріске арналған шешімдер',
      title: 'Сіздің өндірісіңізге қандай шешім сәйкес келеді',
      subtitle: 'Жүйені өнім түріне, желіге және пайдалану шарттарына қарай таңдаймыз',
      cards: [
        {
          id: 1,
          title: 'Конвейердегі дана өнімдер үшін',
          description:
            'Өндірістік желідегі қаптамалар, қораптар, лотоктар, пакеттер және басқа дана өнімдерді тексеру.',
          image: '/images/landing/solution-conveyor.jpg',
        },
        {
          id: 2,
          title: 'Сусымалы өнімдер үшін',
          description:
            'Дән, қант, ұн, түйіршіктер, ұнтақтар және басқа сусымалы материалдарды бақылау.',
          image: '/images/landing/solution-bulk.jpg',
        },
        {
          id: 3,
          title: 'Сұйық және паста тәрізді өнімдер үшін',
          description:
            'Фарш, пасталар, соустар және басқа тұтқыр орталарды қоса алғанда, өнімді құбырда тексеру.',
          image: '/images/landing/solution-pipeline.jpg',
        },
        {
          id: 4,
          title: 'Жабдықты қорғау үшін',
          description:
            'Ұсатқыштар, диірмендер, экструдерлер, сорғылар және басқа қымбат жабдықтар алдында металды анықтау.',
          image: '/images/landing/solution-equipment-protection.jpg',
        },
      ],
      cta: {
        text: 'Қандай жүйе түрі қажет екенін білмейсіз бе? Желіні сипаттаңыз, біз шешім таңдаймыз',
        button: 'Желіні сипаттап, кеңес алу',
      },
    },
    industries: {
      eyebrow: 'Қолдану салалары',
      title: 'Азық-түлік және өнеркәсіптік өнімдерге арналған Mesutronic шешімдері',
      subtitle:
        'Металл детекторлар мен сепараторлар ет, сүт, сусымалы, фармацевтикалық және пластик өнімдері бар желілерде қолданылады',
      items: [
        { id: 1, name: 'Ет өнімдері', image: '/images/landing/industry-meat.jpg' },
        { id: 2, name: 'Нан-тоқаш өнімдері', image: '/images/landing/industry-bakery.jpg' },
        { id: 3, name: 'Сүт өнімдері', image: '/images/landing/industry-dairy.jpg' },
        { id: 4, name: 'Дайын тағам', image: '/images/landing/industry-convenience-food.jpg' },
        { id: 5, name: 'Түйіршікті және сусымалы өнімдер', image: '/images/landing/industry-bulk.jpg' },
        { id: 6, name: 'Фармацевтика', image: '/images/landing/industry-pharma.jpg' },
        { id: 7, name: 'Гигиеналық бұйымдар', image: '/images/landing/industry-hygiene.jpg' },
        { id: 8, name: 'Пластиктер', image: '/images/landing/industry-plastics.jpg' },
      ],
    },
    whyUs: {
      eyebrow: 'Артықшылықтар',
      title: 'Неліктен Mesutronic',
      subtitle:
        'Mesutronic металл қоспаларын анықтайтын жабдық өндірісінде 30+ жыл тәжірибеге ие. Қазақстанға техникалық сүйемелдеумен жеткіземіз.',
      items: [
        {
          id: 1,
          title: 'Mesutronic-тің 30+ жыл тәжірибесі',
          description:
            'Mesutronic 1992 жылдан бері металл қоспаларын анықтайтын жабдық шығарады. Жүйелер Қазақстанды қоса алғанда 60+ елдегі зауыттарда жұмыс істейді.',
          icon: 'ri-award-line',
        },
        {
          id: 2,
          title: 'Mesutronic өндірісі Германияда',
          description:
            'Өнеркәсіптік металл детекторларды жобалау және жинау Германияда орындалады. Компоненттер мен электроника EU өнеркәсіптік стандарттарына сәйкес келеді.',
          icon: 'ri-settings-3-line',
        },
        {
          id: 3,
          title: 'Өнім мен жабдықты қорғау',
          description:
            'Бір жүйе екі міндетті шешеді: дайын өнімді металдың түсуінен қорғайды және қымбат жабдықты зақымданудан сақтайды.',
          icon: 'ri-shield-flash-line',
        },
        {
          id: 4,
          title: 'Сіздің желіңізге қарай таңдау',
          description:
            'Өнімді, лента жылдамдығын, қаптама түрін, температураны, ылғалдылықты және өнім әсерін ескереміз. Металл детектор моделі мен конфигурациясын таңдаймыз.',
          icon: 'ri-tools-line',
        },
        {
          id: 5,
          title: 'Өнеркәсіптік пайдалану ресурсы',
          description:
            'Құрылым 24/7 жұмысқа есептелген. Жоспарлы қызмет көрсетілген жағдайда азық-түлік өндірісіне арналған металл детектордың орташа қызмет мерзімі 10-15 жыл.',
          icon: 'ri-time-line',
        },
      ],
    },
    howWeWork: {
      eyebrow: 'Жұмыс процесі',
      title: 'Біз қалай жұмыс істейміз',
      subtitle:
        'Өтінімнен жабдықты іске қосуға дейін - әр кезеңде техникалық сүйемелдеуі бар нақты процесс',
      steps: [
        {
          step: 1,
          title: 'Өтінім',
          description:
            'Сайттағы форманы толтырыңыз немесе міндет сипаттамасын info@tzk-east.com мекенжайына жіберіңіз.',
          icon: 'ri-edit-line',
        },
        {
          step: 2,
          title: 'Техникалық нақтылау',
          description:
            'Өнімді, желі түрін, жылдамдықты, қаптама түрін, пайдалану шарттарын және шешілуі қажет мәселені нақтылаймыз.',
          icon: 'ri-message-3-line',
        },
        {
          step: 3,
          title: 'Жабдықты таңдау',
          description:
            'Параметрлерді талдап, жүйе түрін таңдаймыз: өнеркәсіптік металл детектор, металл сепаратор немесе X-ray. Модельді, рамка өлшемін және шығару конфигурациясын бекітеміз.',
          icon: 'ri-search-line',
        },
        {
          step: 4,
          title: 'Коммерциялық ұсыныс',
          description:
            'КҰ-да модельді, жинақтаманы, жеткізу мерзімін, жабдық құнын және Қазақстанға жеткізу шарттарын бекітеміз.',
          icon: 'ri-file-list-3-line',
        },
        {
          step: 5,
          title: 'Қазақстанға жеткізу',
          description:
            'Көлік және кедендік құжаттаманы рәсімдейміз. Инспекциялық жүйелерді тапсырыс беруші нысанына дейін жеткізуді ұйымдастырамыз.',
          icon: 'ri-truck-line',
        },
        {
          step: 6,
          title: 'Іске қосу-баптау',
          description:
            'Маман нысанға барып, іске қосу-баптау жұмыстарын жүргізеді және жабдықты желіде тексереді.',
          icon: 'ri-tools-line',
        },
        {
          step: 7,
          title: 'Техникалық қолдау',
          description:
            'Жабдықтың бүкіл пайдалану мерзімінде сүйемелдейміз: сұрақтарға жауап береміз, қосалқы бөлшектер жеткіземіз және техникалық қызметке барамыз.',
          icon: 'ri-customer-service-2-line',
        },
      ],
    },
    contact: {
      eyebrow: 'Жабдық таңдауға өтінім',
      title: 'Металл детектор таңдауға өтінім қалдыру',
      subtitle:
        'Өнеркәсіптік металл детекторды дәл таңдау үшін өнімді, желі түрін, жылдамдықты, қаптама өлшемдерін және пайдалану шарттарын білу маңызды. Өтінім қалдырыңыз, біз параметрлерді нақтылап, қолайлы нұсқа ұсынамыз.',
      submitText: 'Таңдауға өтінім жіберу',
      formUrl: '/send-form.php',
      labels: {
        region: 'Өңір',
        name: 'Аты-жөні',
        company: 'Компания',
        phone: 'Телефон',
        email: 'Email',
        city: 'Қазақстандағы қала / өңір',
        industry: 'Сала',
        product: 'Қандай өнімді тексеру қажет?',
        packaging: 'Өнім қапталған ба, әлде қаптамасыз ба?',
        lineType: 'Желі түрі',
        description: 'Міндет сипаттамасы',
      },
      placeholders: {
        name: 'Атыңыз',
        company: 'Компания атауы',
        phone: '+7 (___) ___-__-__',
        email: 'email@company.com',
        city: 'Мысалы, Алматы',
        industry: 'Саланы таңдаңыз',
        product: 'Мысалы, пакеттердегі сүт өнімдері',
        packaging: 'Нұсқаны таңдаңыз',
        lineType: 'Желі түрін таңдаңыз',
        description: 'Өнімді, желі түрін, жылдамдықты, мәселені және пайдалану шарттарын сипаттаңыз',
      },
      industries: [
        'Ет өнімдері',
        'Нан-тоқаш өнімдері',
        'Снэктер',
        'Сүт өнімдері',
        'Сусымалы өнімдер',
        'Фармацевтика',
        'Пластиктер',
        'Басқа',
      ],
      packagingOptions: [
        { value: 'packed', label: 'Қапталған' },
        { value: 'unpacked', label: 'Қаптамасыз' },
      ],
      lineTypeOptions: [
        { value: 'conveyor', label: 'Конвейер' },
        { value: 'pipeline', label: 'Құбыр' },
        { value: 'free-fall', label: 'Еркін құлау' },
        { value: 'other', label: 'Басқа' },
      ],
      errors: {
        required: 'Міндетті өрістерді толтырыңыз: аты-жөні, телефон және email',
        submit: 'Жіберу қатесі. Кейінірек қайталап көріңіз немесе email арқылы хабарласыңыз.',
        connection: 'Байланыс қатесі. Кейінірек қайталап көріңіз.',
      },
      success: 'Өтінім сәтті жіберілді! Біз жақын арада сізбен хабарласамыз.',
      submitting: 'Жіберілуде...',
      consent: 'Батырманы басу арқылы сіз дербес деректерді өңдеуге келісесіз',
    },
    finalCta: {
      title: 'Металл детектор немесе сепараторды желіңізге сай таңдаңыз',
      subtitle:
        'Міндет сипаттамасын жіберіңіз - 2 жұмыс күні ішінде техникалық шешім мен құн есебін аласыз',
      button: 'Өтінім қалдыру',
    },
    notFound: {
      title: 'Бет табылмады',
      text: 'Сұралған бет жоқ. Басты бетке оралу керек пе?',
      button: 'Басты бетке',
    },
    footer: {
      company: 'TZK East',
      description:
        'Қазақстанда металл қоспаларын анықтауға арналған Mesutronic металл детекторларын, металл сепараторларын және инспекциялық жүйелерін жеткізу',
      email: 'info@tzk-east.com',
      country: 'Қазақстан',
      navigationTitle: 'Навигация',
      infoTitle: 'Ақпарат',
      copyright: '© 2026 TZK East. Барлық құқықтар қорғалған.',
      disclaimer:
        'Компания Mesutronic жабдығын жеткізеді. Сайттағы ақпарат анықтамалық сипатта берілген.',
      tagline: 'Mesutronic жабдығын Қазақстанға жеткізу',
      navigation: [
        { label: 'Жабдық', href: '#equipment' },
        { label: 'Салалар', href: '#industries' },
        { label: 'Артықшылықтар', href: '#why-us' },
        { label: 'Байланыс', href: '#contact' },
      ],
    },
  },
  ru: {
    nav: {
      links: [
        { label: 'Оборудование', href: '#equipment' },
        { label: 'Решения', href: '#solutions' },
        { label: 'Отрасли', href: '#industries' },
        { label: 'Преимущества', href: '#why-us' },
        { label: 'Контакты', href: '#contact' },
      ],
      consultation: 'Консультация',
      menuLabel: 'Открыть меню',
      closeLabel: 'Закрыть меню',
    },
    hero: {
      eyebrow: 'Поставка оборудования Mesutronic в Казахстан',
      title: 'Металлодетекторы Mesutronic',
      titleAccent: 'для защиты производства',
      subtitle:
        'Поставка и подбор промышленных металлодетекторов и инспекционных систем в Казахстан для пищевых и фармацевтических предприятий',
      ctaPrimary: 'Подобрать оборудование',
      ctaSecondary: 'Получить консультацию',
      imageAlt: 'Промышленный металлодетектор на конвейерной линии',
      heroImage: '/images/landing/hero.jpg',
      advantages: [
        'Обнаружение Fe, Non-Fe и нержавеющей стали',
        'Решения для конвейеров, трубопроводов и сыпучих потоков',
        'Подбор под продукт, упаковку и скорость линии',
      ],
    },
    trust: {
      eyebrow: 'Поставка оборудования Mesutronic в Казахстан',
      title: 'Оборудование Mesutronic производится в Германии. Поставка в Казахстан',
      subtitle:
        'Промышленные металлодетекторы и инспекционные системы для контроля качества продукции и защиты оборудования',
      imageAlt: 'Здание Mesutronic GmbH в Kirchberg im Wald, Германия',
      heading: 'Немецкое производство Mesutronic для промышленных линий Казахстана',
      paragraphs: [
        'Mesutronic GmbH более 30 лет разрабатывает и производит промышленные системы обнаружения металла и посторонних включений. Штаб-квартира и производство компании находятся в Kirchberg im Wald, Германия, а оборудование используется заказчиками в десятках стран.',
        'В линейке Mesutronic представлены металлодетекторы, металлосепараторы и X-ray инспекционные системы для пищевой промышленности, фармацевтики, гигиенической продукции, пластика, текстиля, деревообработки и горнодобывающего сектора. Решения подбираются под продукт, упаковку, скорость линии и требования к отбраковке.',
        'Для предприятий Казахстана мы помогаем подобрать оборудование Mesutronic под конкретную производственную задачу, подготовить техническую спецификацию и организовать поставку из Германии с учетом логистики, документации и условий внедрения на объекте.',
      ],
      stats: ['30+ лет опыта', '230 сотрудников', '50 стран', '70% экспорта'],
    },
    tasks: {
      eyebrow: 'Решаемые задачи',
      title: 'Оборудование для обнаружения металлических включений',
      subtitle:
        'Промышленные металлодетекторы и металлосепараторы Mesutronic решают ключевые производственные задачи на линиях в Казахстане',
      items: [
        {
          id: 1,
          title: 'Обнаружение металла в продукции и сырье',
          description:
            'Промышленный металлодетектор фиксирует железо, цветные металлы, алюминий, медь, нержавеющую сталь на всех этапах производства.',
          icon: 'ri-radar-line',
        },
        {
          id: 2,
          title: 'Защита технологического оборудования',
          description:
            'Металлические включения повреждают дробилки, мельницы, экструдеры, насосы. Металлосепаратор для производства убирает металл до попадания в оборудование.',
          icon: 'ri-shield-check-line',
        },
        {
          id: 3,
          title: 'Снижение рекламаций и возвратов',
          description:
            'Металл в готовом продукте - причина отгрузочных претензий и штрафов. Инспекция на линии предотвращает выход брака.',
          icon: 'ri-arrow-down-circle-line',
        },
        {
          id: 4,
          title: 'Проверка перед упаковкой и отгрузкой',
          description:
            'Финальная инспекция продукции перед упаковкой или отправкой заказчику. Исключает попадание брака в партию.',
          icon: 'ri-line-chart-line',
        },
        {
          id: 5,
          title: 'Соответствие требованиям безопасности',
          description:
            'HACCP, BRC и внутренние стандарты производителей требуют контроля физических включений. Оборудование фиксирует и документирует каждое срабатывание.',
          icon: 'ri-file-shield-line',
        },
      ],
    },
    equipment: {
      eyebrow: 'Оборудование Mesutronic',
      title: 'Металлодетекторы производства Mesutronic',
      subtitle:
        'Подбор и поставка решений Mesutronic для конвейерных, трубопроводных, гравитационных, упаковочных и фармацевтических линий',
      items: [
        {
          id: 1,
          title: 'Конвейерный металлодетектор Metron 07 CI',
          description:
            'Инспекционная система для контроля штучной и упакованной продукции на конвейерных линиях.',
          image: '/images/landing/mesutronic-metron-07-ci.jpg',
          features: ['Конвейерная линия', 'Упакованная продукция', 'Контроль Fe, Non-Fe, SS'],
        },
        {
          id: 2,
          title: 'Трубопроводный металлодетектор MEATLINE 07',
          description:
            'Решение для контроля мясного фарша, пастообразных и вязких продуктов в трубопроводе.',
          image: '/images/landing/mesutronic-meatline-07.jpg',
          features: ['Мясное производство', 'Пастообразные продукты', 'Работа в трубопроводе'],
        },
        {
          id: 3,
          title: 'Трубопроводный металлодетектор Pipeline 07',
          description:
            'Металлодетектор для жидких, пастообразных и перекачиваемых продуктов на закрытых линиях.',
          image: '/images/landing/mesutronic-pipeline-07.jpg',
          features: ['Жидкие продукты', 'Закрытая линия', 'Санитарное исполнение'],
        },
        {
          id: 4,
          title: 'Гравитационный металлодетектор Quicktron 07 RH',
          description:
            'Система для контроля сыпучих продуктов в свободном падении с автоматическим отводом загрязненного потока.',
          image: '/images/landing/mesutronic-quicktron-07-rh.jpg',
          features: ['Сыпучие продукты', 'Свободное падение', 'Автоматический отвод'],
        },
        {
          id: 5,
          title: 'Горловой металлодетектор METRON 07 FlatLine',
          description:
            'Компактный горловой металлодетектор для установки на вертикальные упаковочные машины и фасовочные линии.',
          image: '/images/landing/mesutronic-metron-07-flatline.jpg',
          features: ['Вертикальная упаковка', 'Компактная установка', 'Контроль перед фасовкой'],
        },
        {
          id: 6,
          title: 'Металлодетектор для таблеток PHARMATRON 07',
          description:
            'Специализированный металлодетектор для контроля таблеток и капсул на фармацевтическом производстве.',
          image: '/images/landing/mesutronic-pharmatron-07.jpg',
          features: ['Фармацевтика', 'Таблетки и капсулы', 'Высокая чувствительность'],
        },
      ],
    },
    solutions: {
      eyebrow: 'Решения для производства',
      title: 'Какое решение подойдет вашему производству',
      subtitle: 'Подбираем систему под тип продукта, линию и условия эксплуатации',
      cards: [
        {
          id: 1,
          title: 'Для штучной продукции на конвейере',
          description:
            'Проверка упаковок, коробок, лотков, пакетов и другой штучной продукции на производственной линии.',
          image: '/images/landing/solution-conveyor.jpg',
        },
        {
          id: 2,
          title: 'Для сыпучих продуктов',
          description:
            'Контроль зерна, сахара, муки, гранул, порошков и других сыпучих материалов.',
          image: '/images/landing/solution-bulk.jpg',
        },
        {
          id: 3,
          title: 'Для жидких и пастообразных продуктов',
          description:
            'Проверка продукта в трубопроводе, включая фарш, пасты, соусы и другие вязкие среды.',
          image: '/images/landing/solution-pipeline.jpg',
        },
        {
          id: 4,
          title: 'Для защиты оборудования',
          description:
            'Обнаружение металла до дробилок, мельниц, экструдеров, насосов и другого дорогостоящего оборудования.',
          image: '/images/landing/solution-equipment-protection.jpg',
        },
      ],
      cta: {
        text: 'Не знаете, какой тип системы нужен? Опишите линию - мы подберем решение',
        button: 'Описать линию и получить консультацию',
      },
    },
    industries: {
      eyebrow: 'Отрасли применения',
      title: 'Решения Mesutronic для пищевых и промышленных продуктов',
      subtitle:
        'Металлодетекторы и сепараторы применяются на линиях с мясной, молочной, сыпучей, фармацевтической и пластиковой продукцией',
      items: [
        { id: 1, name: 'Мясная продукция', image: '/images/landing/industry-meat.jpg' },
        { id: 2, name: 'Хлебобулочные изделия', image: '/images/landing/industry-bakery.jpg' },
        { id: 3, name: 'Молочная продукция', image: '/images/landing/industry-dairy.jpg' },
        { id: 4, name: 'Готовая еда', image: '/images/landing/industry-convenience-food.jpg' },
        { id: 5, name: 'Гранулированные и сыпучие продукты', image: '/images/landing/industry-bulk.jpg' },
        { id: 6, name: 'Фармацевтика', image: '/images/landing/industry-pharma.jpg' },
        { id: 7, name: 'Гигиенические изделия', image: '/images/landing/industry-hygiene.jpg' },
        { id: 8, name: 'Пластики', image: '/images/landing/industry-plastics.jpg' },
      ],
    },
    whyUs: {
      eyebrow: 'Преимущества',
      title: 'Почему Mesutronic',
      subtitle:
        'Mesutronic - 30+ лет опыта в производстве оборудования для обнаружения металлических включений. Поставка в Казахстан с техническим сопровождением.',
      items: [
        {
          id: 1,
          title: '30+ лет опыта Mesutronic',
          description:
            'Mesutronic производит оборудование для обнаружения металлических включений с 1992 года. Системы работают на заводах в 60+ странах, включая Казахстан.',
          icon: 'ri-award-line',
        },
        {
          id: 2,
          title: 'Производство Mesutronic в Германии',
          description:
            'Проектирование и сборка промышленных металлодетекторов в Германии. Компоненты и электроника соответствуют промышленным стандартам EU.',
          icon: 'ri-settings-3-line',
        },
        {
          id: 3,
          title: 'Защита продукции и оборудования',
          description:
            'Одна система закрывает две задачи: защищает конечный продукт от попадания металла и защищает дорогостоящее оборудование от повреждений.',
          icon: 'ri-shield-flash-line',
        },
        {
          id: 4,
          title: 'Подбор под вашу линию',
          description:
            'Учитываем продукт, скорость ленты, тип упаковки, температуру, влажность, эффект продукта. Подбираем модель металлодетектора и конфигурацию.',
          icon: 'ri-tools-line',
        },
        {
          id: 5,
          title: 'Ресурс для промышленной эксплуатации',
          description:
            'Конструкция рассчитана на работу 24/7. Средний срок службы металлодетектора для пищевого производства - 10-15 лет при плановом обслуживании.',
          icon: 'ri-time-line',
        },
      ],
    },
    howWeWork: {
      eyebrow: 'Процесс работы',
      title: 'Как мы работаем',
      subtitle:
        'От заявки до запуска оборудования - четкий процесс с техническим сопровождением на каждом этапе',
      steps: [
        {
          step: 1,
          title: 'Заявка',
          description:
            'Заполните форму на сайте или отправьте запрос на info@tzk-east.com с описанием задачи.',
          icon: 'ri-edit-line',
        },
        {
          step: 2,
          title: 'Техническое уточнение',
          description:
            'Уточняем продукт, тип линии, скорость, тип упаковки, условия эксплуатации и проблему, которую нужно решить.',
          icon: 'ri-message-3-line',
        },
        {
          step: 3,
          title: 'Подбор оборудования',
          description:
            'Анализируем параметры и подбираем тип системы - промышленный металлодетектор, металлосепаратор или X-ray. Фиксируем модель, размер рамки, конфигурацию отбраковки.',
          icon: 'ri-search-line',
        },
        {
          step: 4,
          title: 'Коммерческое предложение',
          description:
            'Фиксируем в КП модель, комплектацию, срок поставки, стоимость оборудования и условия доставки в Казахстан.',
          icon: 'ri-file-list-3-line',
        },
        {
          step: 5,
          title: 'Поставка в Казахстан',
          description:
            'Оформляем транспортную и таможенную документацию. Организуем доставку инспекционных систем до объекта заказчика.',
          icon: 'ri-truck-line',
        },
        {
          step: 6,
          title: 'Пусконаладочные работы',
          description:
            'Специалист выезжает на объект для проведения пусконаладочных работ и проверки оборудования на линии.',
          icon: 'ri-tools-line',
        },
        {
          step: 7,
          title: 'Техническая поддержка',
          description:
            'Сопровождаем оборудование весь срок эксплуатации: отвечаем на вопросы, поставляем запчасти и выезжаем на техобслуживание.',
          icon: 'ri-customer-service-2-line',
        },
      ],
    },
    contact: {
      eyebrow: 'Заявка на подбор оборудования',
      title: 'Оставить заявку на подбор металлодетектора',
      subtitle:
        'Для точного подбора промышленного металлодетектора важно понимать продукт, тип линии, скорость, размеры упаковки и условия эксплуатации. Оставьте заявку - мы уточним параметры и предложим подходящий вариант.',
      submitText: 'Отправить заявку на подбор',
      formUrl: '/send-form.php',
      labels: {
        region: 'Регион',
        name: 'Имя',
        company: 'Компания',
        phone: 'Телефон',
        email: 'Email',
        city: 'Город / регион в Казахстане',
        industry: 'Отрасль',
        product: 'Какой продукт нужно проверять?',
        packaging: 'Продукт упакован или без упаковки?',
        lineType: 'Тип линии',
        description: 'Описание задачи',
      },
      placeholders: {
        name: 'Ваше имя',
        company: 'Название компании',
        phone: '+7 (___) ___-__-__',
        email: 'email@company.com',
        city: 'Например, Алматы',
        industry: 'Выберите отрасль',
        product: 'Например, молочная продукция в пакетах',
        packaging: 'Выберите вариант',
        lineType: 'Выберите тип линии',
        description: 'Опишите продукт, тип линии, скорость, проблему и условия эксплуатации',
      },
      industries: [
        'Мясная продукция',
        'Хлебобулочные изделия',
        'Снеки',
        'Молочная продукция',
        'Сыпучие продукты',
        'Фармацевтика',
        'Пластики',
        'Другое',
      ],
      packagingOptions: [
        { value: 'packed', label: 'Упакован' },
        { value: 'unpacked', label: 'Без упаковки' },
      ],
      lineTypeOptions: [
        { value: 'conveyor', label: 'Конвейер' },
        { value: 'pipeline', label: 'Трубопровод' },
        { value: 'free-fall', label: 'Свободное падение' },
        { value: 'other', label: 'Другое' },
      ],
      errors: {
        required: 'Пожалуйста, заполните обязательные поля: имя, телефон и email',
        submit: 'Ошибка отправки. Пожалуйста, попробуйте позже или свяжитесь по email.',
        connection: 'Ошибка соединения. Пожалуйста, попробуйте позже.',
      },
      success: 'Заявка успешно отправлена! Мы свяжемся с вами в ближайшее время.',
      submitting: 'Отправка...',
      consent: 'Нажимая кнопку, вы соглашаетесь с обработкой персональных данных',
    },
    finalCta: {
      title: 'Подберите металлодетектор или сепаратор под вашу линию',
      subtitle:
        'Отправьте описание задачи - получите техническое решение и расчет стоимости в течение 2 рабочих дней',
      button: 'Оставить заявку',
    },
    notFound: {
      title: 'Страница не найдена',
      text: 'Запрашиваемая страница не существует. Вернуться на главную?',
      button: 'На главную',
    },
    footer: {
      company: 'TZK East',
      description:
        'Поставка металлодетекторов, металлосепараторов и инспекционных систем Mesutronic для обнаружения металлических включений в Казахстане',
      email: 'info@tzk-east.com',
      country: 'Казахстан',
      navigationTitle: 'Навигация',
      infoTitle: 'Информация',
      copyright: '© 2026 TZK East. Все права защищены.',
      disclaimer:
        'Компания осуществляет поставку оборудования Mesutronic. Информация на сайте носит справочный характер.',
      tagline: 'Поставка оборудования Mesutronic в Казахстан',
      navigation: [
        { label: 'Оборудование', href: '#equipment' },
        { label: 'Отрасли', href: '#industries' },
        { label: 'Преимущества', href: '#why-us' },
        { label: 'Контакты', href: '#contact' },
      ],
    },
  },
} as const;

export function getLandingContent(language?: string) {
  return language?.startsWith('ru') ? landingContent.ru : landingContent.kk;
}

export type LandingContent = typeof landingContent.kk;
